var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7585_9321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4999 11.1785L12.9556 13.6341L4.875 18.2994C4.43641 18.5526 3.9401 18.506 3.56832 18.2647L3.47807 18.2003L10.4999 11.1785ZM3 3.67854L9.32142 10L3 16.3214V3.67854ZM14.4498 7.22862L17.375 8.9175C18.2083 9.39858 18.2083 10.6014 17.375 11.0825L14.4498 12.7713L11.6785 10L14.4498 7.22862ZM4.875 1.70058L12.9555 6.36588L10.4999 8.8215L3.47809 1.79962C3.85699 1.50387 4.39986 1.42626 4.875 1.70058Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7585_9321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChPlay);
export default __webpack_public_path__ + "static/media/ch-play.55eea60c1cf141acc96a3a7cdfdecb75.svg";
export { ForwardRef as ReactComponent };